import React, { useCallback, useMemo } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { ExceptionEntityTableRows } from '../../../../../../components';
import {
  createModalTableRowsData,
  updateCheckedProductVariants,
  updateCheckedProducts
} from '../../methods';

export default function Rows({
  products = [],
  searchQuery = '',
  checked = {},
  expanded = {},
  onToggle = () => {},
  onCheck = () => {}
}) {
  const onSelectProduct = useCallback(
    (product = {}, productVariants = []) => {
      const productId = _get(product, 'ObjectId', '');

      if (!productId || _isEmpty(productVariants)) return;

      onToggle(productId, true);
      onCheck(checked => {
        return updateCheckedProducts(checked, product, productVariants);
      });
    },
    [onToggle, onCheck]
  );

  const onSelectProductVariant = useCallback(
    (product, productVariant = {}) => {
      const productId = _get(product, 'ObjectId', '');
      const productVariantId = _get(productVariant, 'objectID');

      if (!productId || !productVariantId) return;

      onCheck(checked => {
        const lol = updateCheckedProductVariants(
          checked,
          product,
          productVariant
        );
        return lol;
      });
    },
    [onCheck]
  );

  const rows = useMemo(() => {
    return createModalTableRowsData({
      products,
      searchQuery,
      selected: checked,
      onSelectProduct,
      onSelectProductVariant
    });
  }, [products, searchQuery, checked, onSelectProduct, onSelectProductVariant]);

  return (
    <ExceptionEntityTableRows
      rows={rows}
      active={expanded}
      onClick={onToggle}
    />
  );
}
